function MoneyMoney() {
    window['yaContextCb'] = window['yaContextCb'] || [];

    let pageWidth, isYandexRTBLoaded = false;

    this.run = function () {
        pageWidth = Math.max(
            document.documentElement["clientWidth"], document.body["scrollWidth"],
            document.documentElement["scrollWidth"], document.body["offsetWidth"],
            document.documentElement["offsetWidth"]
        );
        [].slice.call(document.querySelectorAll('.yarb')).map(function (place) {
            if (place.classList.contains('yarb-rendered') || place.classList.contains('yarb-skip')) {
                return;
            }
            let cElement = place, style = null, isHidden = false;
            while (cElement) {
                if (cElement.constructor['name'] === 'HTMLDocument') {
                    break;
                }
                style = window.getComputedStyle(cElement, null);
                if (style.display === 'none') {
                    isHidden = true;
                    break;
                }
                cElement = cElement.parentNode;
            }
            if (isHidden) {
                place.classList.add('yarb-skip');
                return;
            }
            place.classList.add((pageWidth < 992 ? 'yarb-mobile' : 'yarb-desktop'));
            let rtbBlockId = 'R-A-147011-' + (pageWidth < 992 ? place.dataset.mobile : place.dataset.desktop);
            place.setAttribute('id', 'yandex_rtb_' + rtbBlockId);
            place.classList.add('yarb-rendered');
            window['yaContextCb'].push(() => {
                window['Ya']['Context']['AdvManager'].render({
                    blockId: rtbBlockId,
                    renderTo: 'yandex_rtb_' + rtbBlockId,
                    onRender: function(data) {
                        console.log('render successful', data)
                    },
                }, function() {
                    console.log('fallback successful')
                });
            });
        });

        if (document.querySelectorAll('.adsbygoogle').length > 0) {
            console.log('loading adsense...');
            getScript('//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js');
        }

        loadYandexRTB();
    };

    function loadYandexRTB() {
        if (isYandexRTBLoaded) return;
        // setTimeout(function () {
        //     if (!window['Ya'] || !window['Ya']['Context']) {
        //         console.log('adblocker you are!');
        //     }
        // }, 3000);
        getScript('https://yandex.ru/ads/system/context.js');
        isYandexRTBLoaded = true;
    }
}
var moneyMoney = new MoneyMoney();
document.addEventListener('DOMContentLoaded', function () { setTimeout(function () { moneyMoney.run(); }, 150) });

function getScript(source, callback) {
    let script = document.createElement('script');
    let prior = document.getElementsByTagName('script')[0];
    script.async = true;

    script.onload = script.onreadystatechange = function( _, isAbort ) {
        if(isAbort || !script.readyState || /loaded|complete/.test(script.readyState) ) {
            script.onload = script.onreadystatechange = null;
            script = undefined;
            if(!isAbort && callback) setTimeout(callback, 0);
        }
    };

    script.src = source;
    prior.parentNode.insertBefore(script, prior);
}